<template>
    <div class="editRecord">
        <page-header :title="title"></page-header>
        <div class="content">
            <write :formData="formData" @efficacyTrackSave="efficacyTrackSave"></write>
        </div>
        <prev-page @back="back" :text="'返回看记录'"></prev-page>
    </div>
</template>
<script>
    import write from '../trackRecord/components/write.vue'
    import { efficacyTrackUpdate } from '../../api/index'
    export default {
        components: {
            write
        },
        data() {
            return {
                title: '编辑记录',
                formData: {
                    efficacyTrackId: '',
                    userNo: '',
                    userMemberId: '',
                    userMemberName: '',
                    diseaseType: '',
                    trackContent: '',
                    trackPic: [],
                    trackStatus: '',
                    trackTime: '',
                    trackType: '',
                    nextTrackTime: '',
                    trackRemark: ''
                },
            }
        },
        created() {
            let data = JSON.parse(sessionStorage.getItem('editRecord'))
            console.log(data)
            Object.keys(this.formData).forEach(key => {
                if(key == 'trackPic'){
                    if(!data.trackPic){
                        this.formData.trackPic = []
                    }else {
                        this.formData.trackPic = data.trackPic.split(',')
                        this.formData.trackPic = this.formData.trackPic.map(item => {
                            return {url: item}
                        })
                    }
                }else {
                    this.formData[key] = data[key]
                }
            })
        },
        methods: {
            back() {
                this.$dialog.confirm({
                    title: '',
                    message: '记录尚未保存，未保存的记录将不作保留，是否继续返回首页？',
                    confirmButtonText: '是',
                    cancelButtonText: '否'
                }).then(() => {
                    this.$router.back()
                }).catch(() => {
                    
                });
            },
            efficacyTrackSave(formData) {
                let data = Object.assign({}, formData)
                let trackPic = [].concat(data.trackPic)
                if(trackPic.length > 0){
                    data.trackPic = trackPic.map(item => item.url)
                    data.trackPic = data.trackPic.join(',')
                }else {
                    data.trackPic = ''
                }
                efficacyTrackUpdate(data).then(res => {
                    if(res.code == 0){
                        this.$toast.success('修改疗效跟进记录成功')
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
.editRecord {
    padding: 0 10px;
    padding-bottom: 90px;
    .content {
        background: #fff;
        border-radius: 4px;
        padding-bottom: 30px;
        height: calc(100vh - #{170px});
        overflow-y: auto;
    }
}
</style>